import { Error as ErrorInfo } from '../types/Errors/Error'
import { HttpError as HttpErrorInfo } from '../types/Errors/HttpError'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

// TODO: use AutoMapper implementation for Typescript if needed
export default class Mapper {
  static mapError(err): ErrorInfo {
    if (err.httpStatusCode) {
      if (err.httpStatusCode === 500) {
        return { code: err.internalErrorKey, httpResponseCode: err.httpStatusCode, message: StringResources.getString(Strings.Common.InternalError) } as HttpErrorInfo
      }
      return { code: err.internalErrorKey, httpResponseCode: err.httpStatusCode, message: err.message } as HttpErrorInfo
    }
    return { message: StringResources.getString(Strings.Common.InternalError) } as ErrorInfo
  }
}



// WEBPACK FOOTER //
// ./src/utils/Mapper.ts